import { render, staticRenderFns } from "./PaginatedDataTable.vue?vue&type=template&id=e4c2f876&scoped=true"
import script from "./PaginatedDataTable.vue?vue&type=script&lang=js"
export * from "./PaginatedDataTable.vue?vue&type=script&lang=js"
import style0 from "./PaginatedDataTable.vue?vue&type=style&index=0&id=e4c2f876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c2f876",
  null
  
)

export default component.exports